import classNames from 'classnames';
import { LitElement, html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { AtlFormTextAreaProps } from './form.props';
import { getGlobalStyleSheets } from '../../global-styles';
import { Sizes, enumAttributeConverter, SizesValuesMap } from '../enum-types';
import { ifDefined } from 'lit/directives/if-defined.js';

import * as TagNames from './form.tagnames';

@customElement(TagNames.FormTextArea)
export class AtlFormTextArea
   extends LitElement
   implements AtlFormTextAreaProps
{
   declare inputId: string;
   declare inputClassName?: string;
   declare value?: string;
   declare size?: Sizes;
   declare disabled?: boolean;
   declare placeholder?: string;

   static properties = {
      inputId: { type: String },
      inputClassName: { type: String },
      value: { type: String },
      size: {
         type: String,
         convertor: enumAttributeConverter(Sizes, Sizes.Medium),
      },
      disabled: { type: Boolean },
      placeholder: { type: String },
   };

   static styles = [...getGlobalStyleSheets()];

   render() {
      return html`
         <textarea
            id=${this.inputId}
            class=${classNames(
               'form-control',
               this.inputClassName,
               SizesValuesMap[this.size ?? Sizes.Medium]
            )}
            title=${this.title}
            @keyup=${this._handleKeyUp}
            ?disabled="${this.disabled ?? false}"
            placeholder=${ifDefined(this.placeholder)}
         >
${this.value}</textarea
         >
      `;
   }

   private _handleKeyUp = (event: Event) => {
      const newValue =
         ((event.target as HTMLInputElement)?.value as string)?.trim() ?? '';
      this.value = newValue;
      this.dispatchEvent(
         new CustomEvent('inputChange', {
            detail: { payload: newValue },
            bubbles: true,
            composed: true,
         })
      );
   };
}
